import FeaturesContainer from './FeaturesContainer';

const EmergencyAlerts = ({ history, onePage }) => (
  <FeaturesContainer
    history={history}
    onePage={onePage}
    title={'auto_sos'}
    adaptiveHeight={830}
    eventName={'onboardingSos'}
    nextPage={'/choose-your-target'}
    imagePreload={'../assets/checkmark-circle.svg'}
    imageName={'EmergencyAlert'}
    imageAlt={'Auto SOS calls'}
  />
);

export default EmergencyAlerts
